module.exports = __webpack_public_path__ + "img/boat.f3b599c1.svg";